import { SOURCE_LABELS } from "@vaulted/shared";

/** A small tag on records brought in from the old system ("Boulevard"). */
export function SourceBadge({ source }: { source: string | null | undefined }) {
  if (!source) return null;
  return (
    <span title="Brought in from the old system, as it was there" className="rounded-full bg-mist px-2 py-0.5 text-xs font-semibold text-ink-soft">
      {SOURCE_LABELS[source] ?? source}
    </span>
  );
}
